export default __webpack_public_path__ + "static/media/edit.a3085422.svg";